import { Box, Modal, Sheet, Textarea } from "@mui/joy";
import { SClose, SSave } from "../../../../../styles/StyledMUI";
import DarkTypography from "../../../../common/DarkTypography";
import IconButtonCTA from "../../../../common/IconButtonCTA";
import { colorTokens, textTokens, withAlpha } from "../../../../../styles/globalStyles";

type DiveCommentPopupModalProps = {
  open: boolean;
  comment: string;
  position: { top: number; left: number } | null;
  onCommentChange: (value: string) => void;
  onClose: (save: boolean) => void;
};

export default function DiveCommentPopupModal({
  open,
  comment,
  position,
  onCommentChange,
  onClose,
}: DiveCommentPopupModalProps) {
  return (
    <Modal
      open={open}
      onClose={() => onClose(false)}
      disableScrollLock
      keepMounted={false}
      sx={{
        position: "absolute",
        zIndex: 9999,
        top: position ? `${position.top}px` : "50%",
        left: position ? `${position.left}px` : "50%",
        transform: position ? "none" : "translate(-50%, -50%)",
      }}
      slotProps={{
        backdrop: { sx: { opacity: 0.1 } },
      }}
    >
      <Sheet
        sx={{
          p: 2,
          width: { xs: 280, sm: 350 },
          maxHeight: { xs: "calc(100vh - 100px)", sm: "auto" },
          boxShadow: "lg",
          borderRadius: "md",
          border: "1px solid",
          borderColor: withAlpha(textTokens.color.inverse, 0.15),
          backgroundColor: colorTokens.bg.sheetLight,
          color: textTokens.color.bodyOnLight,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: { xs: "flex", sm: "none" },
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <DarkTypography level="title-sm" colorVariant="onLight" sx={{ fontWeight: "bold" }}>
            Commentaire
          </DarkTypography>
          <Box sx={{ display: "flex", gap: 1 }}>
            <IconButtonCTA
              size="sm"
              ctaVariant="success"
              aria-label="Enregistrer commentaire"
              onClick={() => onClose(true)}
            >
              <SSave />
            </IconButtonCTA>
            <IconButtonCTA
              size="sm"
              ctaVariant="danger"
              aria-label="Fermer commentaire"
              onClick={() => onClose(false)}
            >
              <SClose />
            </IconButtonCTA>
          </Box>
        </Box>

        <DarkTypography
          level="title-sm"
          colorVariant="onLight"
          sx={{
            mb: 1,
            display: { xs: "none", sm: "block" },
            fontWeight: "bold",
          }}
        >
          Commentaire
        </DarkTypography>

        <Textarea
          value={comment}
          onChange={(e) => onCommentChange(e.target.value)}
          minRows={5}
          maxRows={10}
          sx={{
            mb: 1,
            width: "100%",
            flexGrow: 1,
            color: textTokens.color.bodyOnLight,
            bgcolor: colorTokens.bg.sheetLight,
            borderColor: withAlpha(textTokens.color.bodyOnLight, 0.2),
            "& textarea": {
              color: textTokens.color.bodyOnLight,
            },
          }}
          autoFocus
        />

        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <IconButtonCTA
            size="sm"
            ctaVariant="success"
            aria-label="Enregistrer commentaire"
            onClick={() => onClose(true)}
          >
            <SSave />
          </IconButtonCTA>
          <IconButtonCTA
            size="sm"
            ctaVariant="danger"
            aria-label="Fermer commentaire"
            onClick={() => onClose(false)}
          >
            <SClose />
          </IconButtonCTA>
        </Box>
      </Sheet>
    </Modal>
  );
}
